/**
 * Created by claudenbach on 2/16/2017.
 */

import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import {LMFormatterService} from "@app/components";

export const lmBooleanSerializer = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  value: string,
  oldValue: string,
  columnDef: ListGridColumn,
  row: number,
  cell: number,
  dataView: any
): boolean => {

  if (lmFormatUtilService.lmFieldUtilService.isBlank(columnDef.displayField.type, value)) {
    const targetDataView = lmFormatterService.listSpec?.isTemplateList ? dataView.dataView : dataView;
    value = targetDataView.fields[ columnDef.fieldId ].value;
  }

  return lmFormatUtilService.booleanToData(value);
};
